import { useContext } from "react";

import { OthersContext } from "shared/catalog/OthersCatalog/OthersContext/index";

export const useOthersContext = () => {
  const othersContext = useContext(OthersContext);

  if (othersContext === undefined) {
    throw new Error(
      "useOthersContext must be used within OthersContextProvider",
    );
  }

  return othersContext;
};
